import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Input,
  OnInit,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import { locale } from '@iv/shared/components/dropdown-new/dropdown-new.locale';
import { Destroyer } from 'app/common/utils';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'iv-live-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TextInputComponent),
    multi: true
  }]
})
export class TextInputComponent extends Destroyer implements ControlValueAccessor, OnInit, AfterViewInit {

  constructor(
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {
    super();
  }

  @Input()
  public label: string;

  @Input()
  public set placeholder(value: any) {
    if (!value) {
      this._placeholder = locale.defaultPlaceholder;
      return;
    }

    this._placeholder = value;
  }

  @Input()
  public set withoutDivider(value: '' | boolean) {
    if (value === '' || value === true) {
      this._withoutDivider = true;
    }
  }

  @Input()
  public set withoutHover(value: '' | boolean) {
    if (value === '' || value === true) {
      this._withoutHover = true;
    }
  }

  public controlValue = new FormControl();

  private _withoutHover: boolean;
  private _disabled = false;
  private _placeholder: string;
  private _withoutDivider: boolean;

  public get placeholder() {
    return this.controlValue.value ? null : this._placeholder;
  }

  public get withoutDivider() {
    return this._withoutDivider;
  }

  public get withoutHover() {
    return this._withoutHover;
  }

  public get disabled(): boolean {
    return this._disabled;
  }

  public set disabled(value: boolean) {
    this._disabled = value;
    this.changeDetectorRef.detectChanges();
  }

  public ngOnInit(): void {
    this.controlValue.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((text: string) => this.onChange(text));
  }

  public ngAfterViewInit(): void {
    this.changeDetectorRef.detectChanges();
  }

  // ----------- Методы ControlValueAccessor -----------
  // Вызовет форма, если значение изменилось извне
  public writeValue(outsideValue: any): void {
    if (!outsideValue) return;

    this.controlValue.setValue(outsideValue);
  }

  // Сохраняем обратный вызов для изменений
  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  // Сохраняем обратный вызов для "касаний"
  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  // Вызовем когда значение изменится
  private onChange(_: any): void {
  }

  // Вызовем при любом действии пользователя с контроллом
  private onTouched(): void {
  }

  // Установка состояния disabled
  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
